import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import { TextBlockStyleSidebar } from '@package/components';

const Sidebar = (props) => {
  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage id="Testo" defaultMessage="Testo" />
        </h2>
      </header>
      <TextBlockStyleSidebar
        {...props}
        titleColorOptions={[]}
        backgroundColorOptions={[
          { name: 'white', label: 'Bianco' },
          { name: 'light-grey', label: 'Grigio' },
          { name: 'blue', label: 'Blu' },
        ]}
      />
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  fullWidth: PropTypes.bool,
  bg_color: PropTypes.string,
  title_color: PropTypes.string,
  share_social: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Sidebar;
